import Colors from 'shared/styles/colors';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 200px 20px 0 20px;
  max-width: 1480px;
  margin: 0 auto;
  min-height: 100vh;
`

const ShopBox = styled.div `
  display: flex;
  justify-content: center;
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }

`

const ImageContainer = styled.div`
  border-radius: 10px;
  img {
    height: 333px;
    box-shadow: 10px 10px 10px 0 rgba(0,0,0,0.75);
    margin-right: 50px;
    border-radius: 10px;
      @media screen and (max-width: 767px) {
        width: 95%;
        margin-bottom: 10px;
      }
  }
`

const Content = styled.div`
  background-color: ${Colors.white};
  padding: 20px;
  border-radius: 10px;
  width: 50%;
  height: 333px;
    @media screen and (max-width: 767px) {
      width: 95%
    }
`

const Title = styled.h2`
  font-weight: 700;
`

const Description = styled.p`
  height: 111px;
`

const Author = styled.p`
  display: flex;
  justify-content: flex-end;
`

const Price = styled.p`
  color: rgb(95 141 79);
  font-weight: 600;
  display: flex;
  justify-content: flex-end;
`

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 30px;
    button {
      width: 100%;
    }
`

const InfoBox = styled.div`

`


export default {
  Title,
  Wrapper,
  ShopBox,
  ImageContainer,
  Content,
  Description,
  Author,
  Price,
  ButtonContainer,
  InfoBox,
}